<script>
    import { Container, ScrollAnchor } from '@/components'

    const tableData = {
        employees: [100, 200, 300, 400, 500],
        prices: [25000, 35000, 45000, 55000, 65000]
    }
</script>

<Container>
    <ScrollAnchor id="prices" />
    <h2 class="title">Стоимость зависит от количества сотрудников<br/> и функциональности</h2>

    <div class="description">Для каждой компании цена рассчитывается индивидуально и складывается из стоимости внедрения<br/> 
    EmployeeGate и ежемесячного обслуживания. </div>

    <div class="wrapper scroll-element">
        <div class="table">
            <div class="left-col">
                <div class="col-title">
                    <div>Количество сотрудников,<br/> базовая функциональность</div>
                </div>

                <div class="nums">
                    {#each tableData.employees as e}
                        <div>
                            <div>{`до ${e}`}</div>
                        </div>
                    {/each}
                </div>
            </div>

            <div class="right-col">
                <div class="col-title">
                    <div>Стоимость в месяц</div>
                </div>

                <div class="nums">
                    {#each tableData.prices as p}
                        <div>
                            <div>{`${new Intl.NumberFormat('ru-RU').format(p)} ₽`}</div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>

    <div class="background" slot="background" />
</Container>

<style lang="scss">
    .title {
        line-height: 60px;
        text-align: center;
    }

    .description {
        margin-top: 40px;
        font-size: 20px;
        line-height: 25px;
        text-align: center;
    }

    .wrapper {
        padding-bottom: 130px;

        .table {
            margin: 0 auto;
            margin-top: 60px;
            display: flex;
            justify-content: center;
            box-shadow: 9.12px 6.08px 112.48px rgba(201, 100, 19, 0.14);
            width: min-content;
            border-bottom-left-radius: 50px;
            border-bottom-right-radius: 50px;

            > div {
                width: 505px;

                &.left-col {
                    .col-title {
                        background: #343B45;
                        border-radius: 50px 0 0 0;
                    }

                    .nums {
                        color: #343B45;
                        border-radius: 0 0 0 50px;

                        > div {
                            &:nth-child(odd) {
                                background-color: #ffffff;
                            }

                            &:nth-child(even) {
                                background-color: rgba(52, 59, 69, 0.04);
                            }

                            &:last-of-type {
                                border-bottom-left-radius: 50px;
                            }
                        }
                    }
                }

                &.right-col {
                    .col-title {
                        background: linear-gradient(180deg, #FF8625 0%, #EA5B0C 100%), #F3954A;
                        border-left: 1px solid #F3954A;
                    }

                    .nums {
                        color: #F3954A;
                        border-left: 1px solid #E9E9E9;

                        > div {
                            &:nth-child(odd){
                                background-color: #fffbf8;
                            }

                            &:nth-child(even){
                                background-color: #f7f3f1;
                            }

                            &:last-of-type {
                                border-bottom-right-radius: 50px;
                            }
                        }
                    }
                }

                .col-title {
                    display: flex;
                    height: 136px;
                    align-items: center;
                    text-align: center;
                    font-size: 26px;
                    font-weight: 700;
                    line-height: 33px;
                    color: #ffffff;

                    > div {
                        flex: 1;
                    }
                }

                .nums {
                    > div {
                        display: flex;
                        align-items: center;
                        text-align: center;
                        height: 96px;

                        > div {
                            flex: 1;
                            font-weight: bold;
                            font-size: 26px;
                            line-height: 33px;
                        }
                    }
                }
            }
        }

    }

    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% - (62px * 2));
        height: 100%;
        margin: 0 62px;
        background-image: url('../img/benefits-background.png');
        background-repeat: no-repeat;
        background-size: 100%;
        background-position-y: bottom;
    }

    @media (max-width: 834px) {
        .title,
        .description {
            br {
                display: none;
            }
        }

        .wrapper {
            padding-bottom: 90px;
            
            div.table {
                width: auto;

                > div {
                    width: 50%;
                }
            }
        }
    }
    @media (max-width: 420px) {
        .wrapper {
            div.table {
                .col-title {
                    font-size: 14px;
                    line-height: 18px;
                    padding: 0 10px;
                }

                .nums {
                    > div {
                        height: 60px;

                        > div {
                            font-size: 14px;
                            line-height: 18px;
                        }
                    }
                }
            }
        }
    }
</style>